import { Component, Inject, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  title: string;
  description: string;
  description2: string;
  descriptionHtml: SafeHtml;

  cancelButton = 'Cancel';
  confirmButton = 'Confirm';
  hasDescription = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = data.title;
    this.description = data.description;
    this.descriptionHtml = data.descriptionHtml;
    this.description2 = data.description2;
    this.hasDescription = (!!this.description || !!this.description2 || this.descriptionHtml != null);
    if (!!data.cancelButton) {
      this.cancelButton = data.cancelButton;
    }
    if (!!data.confirmButton) {
      this.confirmButton = data.confirmButton;
    }
  }

  ngOnInit() {
  }

}
